module.exports = __webpack_public_path__ + "img/img_case_detail_bg.099e049a.png";